<script>
   export let id;
</script>
boats {id}
